import SegmentConstants from './SegmentConstants';
import constants from './CommonConstants';

const { OPPORTUNITY_LEVEL, RISK_LEVEL } = constants;

export const PIPELINE_STATUS = {
  OPEN: {
    id: 1,
    displayName: 'Open',
    cardColor: 'yellow',
    systemLabel: 'OPEN',
  },
  CLOSED_WON: {
    id: 2,
    displayName: 'Closed Won',
    cardColor: 'green',
    systemLabel: 'CLOSED_WON',
  },
  CLOSED_LOST: {
    id: 3,
    displayName: 'Closed Lost',
    cardColor: 'red',
    systemLabel: 'CLOSED_LOST',
  },
  MITIGATED: {
    id: 4,
    displayName: 'Mitigated',
    cardColor: 'green',
    systemLabel: 'MITIGATED',
  },
  REALISED: {
    id: 5,
    displayName: 'Realised',
    cardColor: 'red',
    systemLabel: 'REALISED',
  },
  ABANDONED: {
    id: 6,
    displayName: 'Abandoned',
    cardColor: 'grey',
    systemLabel: 'ABANDONED',
  },
};

export const PIPELINE_STATUS_ID_MAP = {
  [PIPELINE_STATUS.OPEN.id]: PIPELINE_STATUS.OPEN,
  [PIPELINE_STATUS.CLOSED_WON.id]: PIPELINE_STATUS.CLOSED_WON,
  [PIPELINE_STATUS.CLOSED_LOST.id]: PIPELINE_STATUS.CLOSED_LOST,
  [PIPELINE_STATUS.MITIGATED.id]: PIPELINE_STATUS.MITIGATED,
  [PIPELINE_STATUS.REALISED.id]: PIPELINE_STATUS.REALISED,
  [PIPELINE_STATUS.ABANDONED.id]: PIPELINE_STATUS.ABANDONED,
};

export const PIPELINE_ID_NAME_MAPPING = {
  [PIPELINE_STATUS.OPEN.id]: PIPELINE_STATUS.OPEN.displayName,
  [PIPELINE_STATUS.CLOSED_WON.id]: PIPELINE_STATUS.CLOSED_WON.displayName,
  [PIPELINE_STATUS.CLOSED_LOST.id]: PIPELINE_STATUS.CLOSED_LOST.displayName,
  [PIPELINE_STATUS.MITIGATED.id]: PIPELINE_STATUS.MITIGATED.displayName,
  [PIPELINE_STATUS.REALISED.id]: PIPELINE_STATUS.REALISED.displayName,
  [PIPELINE_STATUS.ABANDONED.id]: PIPELINE_STATUS.ABANDONED.displayName,
};

export const PIPELINE_TYPE = {
  OPPORTUNITY: {
    id: 1,
    displayName: 'Opportunities',
    level: OPPORTUNITY_LEVEL,
  },
  RISK: { id: 2, displayName: 'Risks', level: RISK_LEVEL },
};

export const PIPELINE_ID_MAP = {
  1: OPPORTUNITY_LEVEL,
  2: RISK_LEVEL,
};

export const PIPELINE_ID_LABEL_MAP = {
  [OPPORTUNITY_LEVEL]: 1,
  [RISK_LEVEL]: 2,
};

export const DEFAULT_PIPELINE_TYPE_ID = PIPELINE_TYPE.OPPORTUNITY.id;

export const PIPELINE_ID_TYPE_MAP = {
  [PIPELINE_TYPE.OPPORTUNITY.id]: PIPELINE_TYPE.OPPORTUNITY,
  [PIPELINE_TYPE.RISK.id]: PIPELINE_TYPE.RISK,
};

export const PIPELINE_TYPE_STATUS_MAPPING = {
  [PIPELINE_TYPE.OPPORTUNITY.id]: [
    PIPELINE_STATUS.OPEN,
    PIPELINE_STATUS.CLOSED_WON,
    PIPELINE_STATUS.CLOSED_LOST,
    PIPELINE_STATUS.ABANDONED,
  ],
  [PIPELINE_TYPE.RISK.id]: [
    PIPELINE_STATUS.OPEN,
    PIPELINE_STATUS.MITIGATED,
    PIPELINE_STATUS.REALISED,
    PIPELINE_STATUS.ABANDONED,
  ],
};

const { levels: segmentLevels } = SegmentConstants;

export const SEGMENT_LEVEL_PIPELINE_MAP = {
  [segmentLevels.ORGANISATION_OPPORTUNITY]: constants.OPPORTUNITY_LEVEL,
  [segmentLevels.ORGANISATION_RISK]: constants.RISK_LEVEL,
  [segmentLevels.ACCOUNT_OPPORTUNITY]: constants.OPPORTUNITY_LEVEL,
  [segmentLevels.ACCOUNT_RISK]: constants.RISK_LEVEL,
};
